import React from 'react';

const ITEMS = [
  'Abhyanga', 'Shirodhara', 'Panchakarma', 'Nasyam', 'Pizhichil',
  'Njavarakizhi', 'Udvartana', 'Kati Basti', 'Vamana', 'Virechana',
  'Basti', 'Swedana', '100% Authentic', 'AYUSH Registered', 'Kengeri · Bangalore',
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="marquee-strip">
      <div className="marquee-inner">
        {doubled.map((t, i) => (
          <span key={i} className="marquee-item">
            {t} <span className="marquee-dot" />
          </span>
        ))}
      </div>
    </div>
  );
}
